export enum ApplicationType {
  TICKETING = 0,
  CENTRAL = 1
}
